import logUtil from 'utils/log'
import updateCurrentSidebarAction from 'modules/sidebar/redux/actions/update-current'
import { SIDEBAR_ID } from 'modules/sidebar/constants'

const TITLE = 'Subscriptions'

export default function openSidebarSubscriptionsAction (data = {}) {
  return (dispatch) => {
    logUtil('openSidebarSubscriptionsAction').debug('[start] data=', data)

    data.title = data.title || TITLE
    dispatch(
      updateCurrentSidebarAction(
        SIDEBAR_ID.SUBSCRIPTIONS,
        data
      )
    )
  }
}
